import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'

import { getTiposAtendimentoVinculosByFormularioId } from './_requests'
import { FormularioTipoAtendimentoList } from './_models'
import { useModal } from '../../../../../components'
import { useParams } from 'react-router-dom'

const QueryResponseContext =
  createResponseContext<FormularioTipoAtendimentoList>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const { id } = useParams()
  const formId = Number(id)

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.VINCULOS_ATENDIMENTO_LIST, 'tipoAtendimento', formId, query, isOpen],
    () => getTiposAtendimentoVinculosByFormularioId(query, formId),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
